import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "shadow-lg py-4 px-2 border-t" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-2xl text-gray-700" }, "Props :", -1)
const _hoisted_3 = { class: "table-auto border-collapse w-full mt-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("thead", { class: "text-gray-600 text-left border border-gray-200" }, [
  /*#__PURE__*/_createVNode("th", { class: "p-2" }, "Name"),
  /*#__PURE__*/_createVNode("th", { class: "p-2" }, "Default"),
  /*#__PURE__*/_createVNode("th", { class: "p-2" }, "Type")
], -1)
const _hoisted_5 = { class: "border border-gray-100 text-gray-500" }
const _hoisted_6 = { class: "border border-gray-200" }
const _hoisted_7 = { class: "px-2 py-1" }
const _hoisted_8 = { class: "px-2 py-1" }
const _hoisted_9 = { class: "px-2 py-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("table", _hoisted_3, [
      _hoisted_4,
      _createVNode("tbody", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.component.props, (prop, key, index) => {
          return (_openBlock(), _createBlock("tr", _hoisted_6, [
            _createVNode("td", _hoisted_7, _toDisplayString(key === "modelValue" ? "v-model" : key), 1),
            _createVNode("td", _hoisted_8, _toDisplayString(prop.default), 1),
            _createVNode("td", _hoisted_9, _toDisplayString(prop.type.toString().replace(/function|\(\)|\{|}|native code|\[|\]| /g, "")), 1)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}